/* eslint-disable no-use-before-define */
import React from 'react'
import { useDispatch } from 'react-redux'
import Translations from '@helpers/translations'
import { resetDynamicFilters } from '@store/redux/actions/filterActions'
import styles from './styles.module.scss'
import { Button } from '@components/ui/Button'
import { useRouter } from 'next/router'
import { prefixLocale } from '@helpers/env'

type CollectionNoResultProps = {
  onFilterClear: () => void
}

const CollectionNoResult = ({ onFilterClear }: CollectionNoResultProps) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const clearFilters = () => dispatch(resetDynamicFilters())

  const handleShopNowClick = () => {
    clearFilters()

    router.replace(
      `${prefixLocale()}/collections/${router.query.collectionHandle}`,
      undefined,
      { shallow: true }
    )
  }

  return (
    <div className={`${styles.EmptyCollection} empty__collection`}>
      <span className={styles.EmptyCollection__Header}>Oops!</span>
      <p>
        {Translations.localise('collection.no-results.item-out-of-stock')}{' '}
        {Translations.localise('collection.no-results.please')}{' '}
        <button
          data-testid="clear-filters-button"
          className={styles.ClearFiltersButton}
          onClick={onFilterClear}
        >
          {Translations.localise('collection.no-results.clear-filters')}
        </button>{' '}
        {Translations.localise('collection.no-results.or')}{' '}
        {Translations.localise('collection.no-results.see-all')}
      </p>

      <Button
        onClick={handleShopNowClick}
        variant="primary_outline"
        classes={styles.EmptyCollection__ShopNow}
      >
        Shop Now
      </Button>
    </div>
  )
}

export default CollectionNoResult
